<template>
  <default>
    <div class="cust-motor-wrap">
      <motor-finalization-page :quote-id="quoteId" />
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import MotorFinalizationPage from '@/components/motor/MotorFinalizationPage';

export default {
  name: 'CustomerMotorFinalization',
  components: { Default, MotorFinalizationPage },
  props: {
    quoteId: { type: [String, Number], required: true },
  },
  metaInfo: { title: 'Motor insurance — Complete' },
};
</script>

<style src="@/assets/css/customer-motor.css"></style>
